<button
  *ngIf="!isLoggedIn"
  class="bypass-block-button skip-to-login focus-link"
  tabindex="1"
  (click)="focusOnButtonElement('.anz-login-button')">
  {{ 'wl.anz.bypass_block.skip_to_login' | translate }}
</button>

<button
  *ngIf="isLoggedIn"
  class="bypass-block-button skip-to-logout focus-link"
  tabindex="1"
  (click)="focusOnButtonElement('.anz-logout-button')">
  {{ 'wl.anz.bypass_block.skip_to_logout' | translate }}
</button>

<button
  class="bypass-block-button skip-to-main-content focus-link"
  tabindex="1"
  (click)="focusOnElement('.router-outlet-container')">
  {{ 'wl.anz.bypass_block.skip_to_main_content' | translate }}
</button>
